/* import __COLOCATED_TEMPLATE__ from './loading-skeleton-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {};
}

const LoadingSkeletonCard = templateOnlyComponent<Signature>();
export default LoadingSkeletonCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::LoadingSkeletonCard': typeof LoadingSkeletonCard;
    'reporting/automation/ai-insights/optimize/loading-skeleton-card': typeof LoadingSkeletonCard;
  }
}
